module.exports = __webpack_public_path__ + "6pm-app-icon.4cc7cc0118303146f379ca9e61649214.png";